import React from "react";
import { motion } from "motion/react";
import { useRevealInitial } from "../../lib/motion";

const SandD = ({ title, p1, p2, p3, p4, bulletList, numList }) => {
  return (
    <motion.section
      id={title}
      className="mx-auto max-w-2xl border-t border-ink-800 px-6 py-12"
      initial={useRevealInitial({ opacity: 0, y: 16 })}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ type: "spring", stiffness: 300, damping: 30 }}
    >
      <h2 className="mb-4 text-2xl font-semibold text-mist-100">{title}</h2>
      {p1 && <p className="mb-4 leading-relaxed text-mist-500">{p1}</p>}

      {bulletList && (
        <ul className="mb-4 list-disc space-y-1 pl-5 marker:text-signal-400">
          {bulletList.map((item, i) => (
            <li key={i} className="leading-relaxed text-mist-500">{item}</li>
          ))}
        </ul>
      )}

      {p2 && <p className="mb-4 leading-relaxed text-mist-500">{p2}</p>}

      {numList && (
        <div className="mb-4 space-y-2 font-mono text-sm">
          {Object.entries(numList).map(([label, item]) => (
            <div key={label} className="flex gap-2">
              <span className="font-semibold text-signal-400">{label}:</span>
              <span className="text-mist-500">{item}</span>
            </div>
          ))}
        </div>
      )}

      {p3 && <p className="mb-4 leading-relaxed text-mist-500">{p3}</p>}
      {p4 && <p className="leading-relaxed text-mist-500">{p4}</p>}
    </motion.section>
  );
};

export default SandD;
